export const CAMERA_PRESETS = [
  { id: 'static', label: 'Estática', icon: 'Camera', desc: 'Fijo / Sin movimiento' },
  { id: 'pan-slow', label: 'Paneo', icon: 'MoveHorizontal', desc: 'Desplazamiento horizontal' },
  { id: 'zoom-in', label: 'Zoom In', icon: 'ZoomIn', desc: 'Acercamiento dramático' },
  { id: 'orbit', label: 'Orbital', icon: 'RotateCw', desc: 'Giro 360° suave' },
  { id: 'tilt-up', label: 'Tilt Up', icon: 'MoveVertical', desc: 'Elevación vertical' },
  { id: 'handheld', label: 'Orgánica', icon: 'Activity', desc: 'Cámara en mano / Cinematográfico' }
];

export const ASPECT_RATIOS = [
  { id: '16:9', label: '16:9', tag: 'YouTube / PC', width: 20, height: 12 },
  { id: '9:16', label: '9:16', tag: 'TikTok / Reels', width: 12, height: 20 },
  { id: '1:1', label: '1:1', tag: 'Square / Feed', width: 16, height: 16 },
  { id: '4:5', label: '4:5', tag: 'Social / Post', width: 14, height: 17.5 }
];

export const DURATION_OPTIONS = [
  { id: '5s', label: '5s', sub: 'Rápido' },
  { id: '10s', label: '10s', sub: 'Estándar' },
  { id: '15s', label: '15s', sub: 'Extendido' }
];

export const FPS_OPTIONS = [
  { id: 24, label: '24 FPS', tag: 'Cine' },
  { id: 30, label: '30 FPS', tag: 'Video' },
  { id: 60, label: '60 FPS', tag: 'Ultra Smooth' }
];

export const INITIAL_TAKES = [
  { id: 1, name: 'Take 01 - Close-up 4K', active: true },
  { id: 2, name: 'Take 02 - Golden Hour', active: false },
  { id: 3, name: 'Take 03 - Slow Orbit', active: false }
];

